import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Root from "./pages/root/Root";
// NotFoundPage 는 App 의 에러 폴백으로 이미 메인 번들에 들어간다 — 쪼개면 중복이다.
import NotFoundPage from "./pages/notFound/NotFoundPage";

// 첫 화면(Root)만 즉시 로드하고 나머지는 라우트 단위로 쪼갠다.
// Slate 에디터·dnd-kit 처럼 무거운 의존성이 글쓰기·설정 화면에만 필요한데,
// 한 덩어리로 묶여 있으면 목록만 보러 온 사람도 전부 내려받게 된다.
const LoginPage = lazy(() => import("./pages/auth/LoginPage"));
const SignupPage = lazy(() => import("./pages/auth/SignUpPage"));
const PosterPostPage = lazy(() => import("./pages/newPost/PosterPostPage"));
const DetailPostPage = lazy(() => import("./pages/detailPost/DetailPostPage"));
const UserSettingPage = lazy(() => import("./pages/userSetting/UserSettingPage"));
// UsersPostPage 는 default export 가 아니라 named export 라 한 겹 감싼다.
const UsersPostPage = lazy(() =>
  import("./pages/usersPost/UsersPostPage").then((m) => ({ default: m.UsersPostPage }))
);

function Body() {
  return (
    <>
        <Suspense fallback={<div style={{ padding: "2rem", opacity: 0.5 }}>불러오는 중…</div>}>
          <Routes>
            <Route path="/" element={<Root/>} />
            <Route path="/:nickname/posts/saves" element={<UsersPostPage isTempPostPage={true} />} />
            <Route path="/:nickname/post/:id" element={<DetailPostPage />} />
            <Route path="/:nickname" element={<UsersPostPage />} />
            <Route path="/login" element={<LoginPage/>} />
            <Route path="/signup" element={<SignupPage/>} />
            <Route path="/post/write" element={<PosterPostPage/>} />
            <Route path="/user/setting/:setting/*" element={<UserSettingPage />} />
            {/* 매칭 실패 시 v6 는 아무것도 렌더하지 않는다 — 백지 대신 404 를 보여준다 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
    </>
  );
}

export default Body;
